function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ced6e0;}.b{fill:#fff;fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1215 -44)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 16.556,
  cy: 16.556,
  r: 16.556,
  transform: "translate(1215 44)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(781.016 -5300.613)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M99.815,8.613c-2.4,0-2.7.01-3.641.053a6.48,6.48,0,0,0-2.143.41,4.517,4.517,0,0,0-2.583,2.582,6.451,6.451,0,0,0-.41,2.143c-.042.942-.053,1.243-.053,3.641s.011,2.7.053,3.64a6.491,6.491,0,0,0,.41,2.143A4.518,4.518,0,0,0,94.03,25.81a6.486,6.486,0,0,0,2.144.41c.942.043,1.243.053,3.641.053s2.7-.01,3.64-.053a6.5,6.5,0,0,0,2.145-.41,4.523,4.523,0,0,0,2.582-2.583,6.544,6.544,0,0,0,.41-2.143c.043-.942.054-1.242.054-3.64s-.011-2.7-.054-3.641a6.542,6.542,0,0,0-.41-2.143A4.516,4.516,0,0,0,105.6,9.077a6.5,6.5,0,0,0-2.145-.41c-.942-.043-1.242-.053-3.641-.053ZM99.023,10.2h.792c2.358,0,2.637.008,3.568.051a4.9,4.9,0,0,1,1.64.3,2.921,2.921,0,0,1,1.675,1.676,4.872,4.872,0,0,1,.3,1.639c.043.931.052,1.21.052,3.567s-.009,2.636-.052,3.567a4.871,4.871,0,0,1-.3,1.639,2.924,2.924,0,0,1-1.675,1.675,4.876,4.876,0,0,1-1.64.3c-.931.042-1.21.052-3.568.052s-2.637-.009-3.568-.052a4.9,4.9,0,0,1-1.64-.3,2.925,2.925,0,0,1-1.676-1.675,4.879,4.879,0,0,1-.3-1.639c-.042-.931-.051-1.211-.051-3.569s.008-2.636.051-3.567a4.887,4.887,0,0,1,.3-1.64,2.926,2.926,0,0,1,1.676-1.676,4.88,4.88,0,0,1,1.64-.3c.815-.037,1.13-.048,2.776-.05Zm5.506,1.466a1.059,1.059,0,1,0,1.059,1.059A1.06,1.06,0,0,0,104.529,11.671Zm-4.714,1.238a4.534,4.534,0,1,0,4.534,4.535A4.535,4.535,0,0,0,99.815,12.909Zm0,1.591a2.943,2.943,0,1,1-2.943,2.944A2.944,2.944,0,0,1,99.815,14.5Z",
  transform: "translate(351 5344)"
})));

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.111,
    height: 33.111,
    viewBox: "0 0 33.111 33.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.90f0923a.svg";
export { ForwardRef as ReactComponent };